import React, { useEffect } from "react";
import Seo from "../../../shared/ui/Seo";
import { useNavigate } from "react-router-dom";
import { onePayCheckStatus } from "../payments/onePay";

const PaymentVerification = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const verifyPayment = async () => {
      // const paymentResult = sessionStorage.getItem("paymentResult");
      // if (paymentResult) {
      //   if (paymentResult === "success") {
      //       sessionStorage.removeItem("onePayTransactionId"); // Clear the transaction ID after successful verification
      //     navigate("/returnSuccess");
      //   } else {
      //       sessionStorage.removeItem("onePayTransactionId"); // Clear the transaction ID after successful verification
      //     navigate("/returnCanceled");
      //   }
      //   return;
      // }

      const orderId = sessionStorage.getItem("orderId");
      if (!orderId) {
        console.error("No order ID found in session storage.");
        navigate("/");
        return;
      }
      // Retrieve the transaction ID from session storage (or URL query parameter)
      const onePayTransactionId = sessionStorage.getItem("onePayTransactionId");
      // If no transaction ID exists, immediately redirect to failure
      if (!onePayTransactionId) {
        navigate("/returnCanceled");
        return;
      }

      try {
        // Make the API call to verify the status
        const response = await onePayCheckStatus();
        //console.log("OnePay Check Status Response:", response);

        // Based on the response, redirect to the correct page:
        if (response && response.status) {
          sessionStorage.removeItem("onePayTransactionId"); // Clear the transaction ID after successful verification
          sessionStorage.setItem("paymentResult", "success");
          navigate("/returnSuccess");
        } else {
          sessionStorage.removeItem("onePayTransactionId"); // Clear the transaction ID after successful verification
          sessionStorage.setItem("paymentResult", "failure");
          navigate("/returnCanceled");
        }
      } catch (error) {
        sessionStorage.removeItem("onePayTransactionId"); // Clear the transaction ID after successful verification
        console.error("Error verifying payment:", error);
        navigate("/returnCanceled");
      }
    };

    verifyPayment();
  }, [navigate]);

  return (
    <div className="container text-center mt-5">
      <Seo title="Payment Verification" noindex />
      <h6 className="mb-4">Verifying Payment...</h6>
      <div
        className="spinner-border text-primary"
        role="status"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3">Please wait while we confirm your payment status.</p>
    </div>
  );
};

export default PaymentVerification;
